<template>  
  <div v-if="SelectedMarkup != null" style="background-color: #faf7c3; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items:center; min-width: 150px; pointer-events: none" :style="{'top' : SelectedMarkup.Coords.Y + 60 + 'px', 'left' : SelectedMarkup.Coords.X + 'px', 'position' : 'absolute'}">
    <div style="border-bottom: 2px solid #c9c9c9; width: 100%; font-weight: bold; padding-left: 3px; padding-right: 3px">
      {{SelectedMarkup.Hint}}
    </div>
  </div>
  <div ref="ElementoGrafico">
    <canvas ref="Canvas" :width="WidthGrafico" :height="HeightGrafico"></canvas>
  </div>      
</template>

<script>
import { TZGraphLabelType, TZGraphLine, TZGraphNotchType } from '@/utils/ZGraph.js'
import { TZMathFunct } from '@/utils/ZMathFunct'
import { COLORI_ALLARME_CRONOLOGIA_ACC, SystemInformation, SPESSORE_LINEE_GRAFICI } from '@/SystemInformation'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';

export default 
{
  components: { },
  mixins: [ MixInsGestioneTraduzioni ],
  data() 
  {
    return {
              ObjGrafico      : null,
              SelectedMarkup  : null,
              Grafici         : {},
              ColoriAllarme   : COLORI_ALLARME_CRONOLOGIA_ACC,
              SpessoreGrafico : SPESSORE_LINEE_GRAFICI,
              LinguaUtente    : SystemInformation.UserInformation.Lingua
           }

  },
  props: [ "WidthGrafico", "HeightGrafico", "Dati", "Repaint", "RepaintDeep", "Tipo", "LivelliAllarme", "TipoAmpiezza" ],

  methods:
  {
    GetMaxAxisY()
    {
      let Result = 0
      if(this.Sensore != undefined)
      {
        for(let i = 0; i < this.Sensore.Dati.length; i++)
        {
          if(Result < this.Sensore.Dati[i].Pitch)
            Result = this.Sensore.Dati[i].Pitch
        }
      }
      return Result
    },

    GetMinAxisY()
    {
      let Result = 0
      if(this.Sensore != undefined)
      {
        for(let i = 0; i < this.Sensore.Dati.length; i++)
        {
          if(Result > this.Sensore.Dati[i].Pitch)
            Result = this.Sensore.Dati[i].Pitch
        }
      }
      return Result
    },

    GetMinDelta(Element)
    {
      return Math.min(Math.abs(Element.MaxAccX - Element.MinAccX), Math.abs(Element.MaxAccY - Element.MinAccY), Math.abs(Element.MaxAccZ - Element.MinAccZ))
    },

    GetMaxDelta(Element)
    {
      return Math.max(Math.abs(Element.MaxAccX - Element.MinAccX), Math.abs(Element.MaxAccY - Element.MinAccY), Math.abs(Element.MaxAccZ - Element.MinAccZ))
    },

    Adatta()
    {
      this.ObjGrafico.AxisX.Min = this.Dati.AxisX.Min
      this.ObjGrafico.AxisX.Max = this.Dati.AxisX.Max
      this.ObjGrafico.AxisX.NotchDim = this.Dati.AxisX.Udm
    },

    GetMousePosOncanvas(event)
    {
      this.ObjGrafico.AnnullaLastMarkup()
      this.SelectedMarkup = null
      this.SelectedMarkup = this.ObjGrafico.HighlightMarkup(event.offsetX, event.offsetY)
    },

    InserisciDati()
    {
      this.ObjGrafico.ClearAllGroupPoint()

      for (let i = 0; i < this.Dati.Generale.Grafici.length; i++)
      {
        let Hint = {}
        let ObjGrafico = this.Dati.Generale.Grafici[i]
        let Grafico = this.ObjGrafico.AddGroupPoint(0, 'blue', this.SpessoreGrafico, true)
        let YCoord = ObjGrafico.Profondita
        let XCoordMax = ObjGrafico.Max
        let XCoordMin = ObjGrafico.Min
        Grafico.AddPoint(XCoordMax, YCoord, Hint, [], null, 'blue')
        Grafico.AddPoint(XCoordMin, YCoord, Hint, [], null, 'blue')
      }

      // for (let i = 0; i < this.Dati.Punti.length; i++)
      // {
      //   let Punto = this.Dati.Punti[i]
      //   let Valore = 0
      //   let ObjLivelliAllarme = {}
      //   let YCoord = Punto.ModuloPrincipale.Profondita
      //   let XCoord = (new Date(Punto.Id)).valueOf()
      //   let Colore = this.ColoriAllarme.Livello0
      //   if (this.TipoAmpiezza)
      //   {
      //     ObjLivelliAllarme = TZGenericFunct.GetCopyOfObject(this.LivelliAllarme.Ampiezza)
      //     Valore = Punto.MaxAmpiezza
      //   }
      //   else
      //   {
      //     ObjLivelliAllarme = TZGenericFunct.GetCopyOfObject(this.LivelliAllarme.Frequenza)
      //     Valore = Punto.Frequenza
      //   }
      //   if (Valore >= ObjLivelliAllarme.Terzo)
      //     Colore = this.ColoriAllarme.Livello3
      //   else
      //   {
      //     if (Valore >= ObjLivelliAllarme.Secondo)
      //       Colore = this.ColoriAllarme.Livello2
      //     else
      //       if (Valore >= ObjLivelliAllarme.Primo)              
      //         Colore = this.ColoriAllarme.Livello1
      //   }
      //   let Hint = Punto.Id + ' - mod. ' + Punto.ModuloPrincipale.Modulo + ' - Max amp. ' + Punto.MaxAmpiezza.toFixed(2) + ' - Nr. eventi ' + Punto.Frequenza + ' - Prof. ' + Punto.ModuloPrincipale.Profondita
      //   Grafico.AddPoint(XCoord, YCoord, Hint, [], null, Colore)
      // }
    },

    Disegna()
    {
      this.Adatta()
      this.InserisciDati()
      setTimeout(() => { this.ObjGrafico.Paint()}, 1)
    },
  },

  computed:
  {
    PropsGraficoPerModifica :
    {
      get()
      {
        return this.PropsGrafico
      }
    }
  },

  watch:
  {
    Repaint:
    {
      handler(NewValue)
      {
        if (NewValue != 0)
        {
          this.ObjGrafico.AxisX.Max      = this.Dati.AsseX.Max
          this.ObjGrafico.AxisX.Min      = this.Dati.AsseX.Min
          this.ObjGrafico.AxisX.NotchDim = this.Dati.AsseX.Udm
          setTimeout(() => { this.ObjGrafico.Paint()}, 1)
        }
      }
    },

    RepaintDeep:
    {
      handler()
      {
        this.Disegna()
      }
    },
  },

  mounted()
  {
    this.ObjGrafico = new TZGraphLine(this.$refs.Canvas)
    this.ObjGrafico.DrawMarkup = false 
    this.ObjGrafico.AxisX.NotchFontSize = 13
    this.ObjGrafico.AxisY.NotchFontSize = 13
    this.ObjGrafico.AxisY.FontSize = 15
    this.ObjGrafico.AxisX.FontSize = 15
    this.ObjGrafico.AxisX.NotchPenWidth = 1
    this.ObjGrafico.AxisY.NotchPenWidth = 1
    this.ObjGrafico.AxisX.NotchColor = 'grey'
    this.ObjGrafico.AxisY.NotchColor = 'grey'
    
    this.ObjGrafico.AxisY.AddLabel(this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']')
    this.ObjGrafico.__Margins.MinLeft   += 30
    
    this.ObjGrafico.AxisX.NotchType = TZGraphNotchType.notStandard
    this.ObjGrafico.AxisY.NotchType = TZGraphNotchType.notStandard
    this.ObjGrafico.AxisX.LabelType = TZGraphLabelType.lblInteger

    if(this.ObjGrafico.AxisX.NotchDim != undefined)
      this.ObjGrafico.AxisX.LabelType    = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisX.NotchDim))

    this.ObjGrafico.AxisX.Min       = this.Dati.AsseX.Min
    this.ObjGrafico.AxisX.Max       = this.Dati.AsseX.Max
    this.ObjGrafico.AxisX.NotchDim  = this.Dati.AsseX.Udm

    this.ObjGrafico.AxisY.Inverted  = true
    this.ObjGrafico.AxisY.Min       = this.Dati.AsseY.Max
    this.ObjGrafico.AxisY.Max       = this.Dati.AsseY.Min
    this.ObjGrafico.AxisY.NotchDim  = this.Dati.AsseY.Udm

    this.InserisciDati()
    // this.$refs.Canvas.addEventListener('mousemove', this.GetMousePosOncanvas)
    setTimeout(() => { this.ObjGrafico.Paint()}, 1)
  },

  beforeMount()
  {
    
  },
}
</script>